module.exports = __webpack_public_path__ + "static/media/2.685d23a2.png";